// import { useState } from 'react'
// import { Dialog, DialogPanel } from '@headlessui/react'
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
// import Logo from '../../../assets/logo.png'
// import { Link, useNavigate } from 'react-router-dom'
// // import { logout } from '../../../utils/auth'
// import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

// const navigation = [
//   { name: 'Home', href: '/home' },
//   { name: 'About', href: '/abouts' },
//   // { name: 'Services', href: '/services' },
//   { name: 'Contact', href: '/contacts' },
//   { name: 'Dashboard', href: '/teacher/dashboard' },
//   // { name: 'Profile', href: '/teacher/profile' },
// ]

// export default function Header() {
//   const navigate = useNavigate()
//   // const toRegister = () => {
//   //   navigate('/register')
//   // }
//   const toLogout = () => {
//     navigate('/logout/')
//     toast.success('You have logged out', {
//       position: 'top-right',
//       autoClose: 3000,
//       theme: 'colored',
//     })
//   }

//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

//   return (
//     <div className="bg-white">
//       <header className="absolute inset-x-0 top-0 z-50">
//         <nav
//           aria-label="Global"
//           className="flex items-center justify-between p-6 lg:px-8"
//         >
//           <div className="flex lg:flex-1">
//             <a href="/" className="-m-1.5 p-1.5">
//               <span className="sr-only">Your Company</span>
//               <Link to="/home">
//                 <img alt="" src={Logo} className="h-8 w-auto" />
//               </Link>
//             </a>
//           </div>
//           <div className="flex lg:hidden">
//             <button
//               type="button"
//               onClick={() => setMobileMenuOpen(true)}
//               className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
//             >
//               <span className="sr-only">Open main menu</span>
//               <Bars3Icon aria-hidden="true" className="h-6 w-6" />
//             </button>
//           </div>
//           <div className="hidden lg:flex lg:gap-x-12">
//             {navigation.map((item) => (
//               <a
//                 key={item.name}
//                 href={item.href}
//                 className="text-sm font-semibold leading-6 text-gray-900"
//               >
//                 {item.name}
//               </a>
//             ))}
//           </div>
//           <button
//             className="hidden lg:flex lg:flex-1 lg:justify-end"
//             type="submit"
//             onClick={toLogout}
//           >
//             Log out <span aria-hidden="true">&rarr;</span>
//           </button>
//         </nav>
//         <Dialog
//           open={mobileMenuOpen}
//           onClose={setMobileMenuOpen}
//           className="lg:hidden"
//         >
//           <div className="fixed inset-0 z-50" />
//           <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
//             <div className="flex items-center justify-between">
//               <a href="#" className="-m-1.5 p-1.5">
//                 <span id="bt" className="sr-only">
//                   Your Company
//                 </span>
//                 <img alt="" src="" className="h-8 w-auto" />
//               </a>
//               <button
//                 type="button"
//                 onClick={() => setMobileMenuOpen(false)}
//                 className="-m-2.5 rounded-md p-2.5 text-gray-700"
//               >
//                 <span className="sr-only">Close menu</span>
//                 <XMarkIcon aria-hidden="true" className="h-6 w-6" />
//               </button>
//             </div>
//             <div className="mt-6 flow-root">
//               <div className="-my-6 divide-y divide-gray-500/10">
//                 <div className="space-y-2 py-6">
//                   {navigation.map((item) => (
//                     <a
//                       key={item.name}
//                       href={item.href}
//                       className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
//                     >
//                       {item.name}
//                     </a>
//                   ))}
//                 </div>
//                 <button className="py-6" type="submit" onClick={toLogout}>
//                   Lout out
//                 </button>
//               </div>
//             </div>
//           </DialogPanel>
//         </Dialog>
//       </header>
//     </div>
//   )
// }

import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import Logo from '../../../assets/logo.png'

const navigation = [
  { name: 'Home', href: '/home' },
  { name: 'About', href: '/abouts' },
  { name: 'Contact', href: '/contacts' },
  { name: 'Dashboard', href: '/teacher/dashboard' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const toLogout = () => {
    setMobileMenuOpen(false)
    navigate('/logout/')
    toast.success('You have logged out', {
      position: 'top-right',
      autoClose: 3000,
      theme: 'colored',
    })
  }

  return (
    <header className="fixed inset-x-0 top-0 z-50 bg-white shadow-sm">
      <nav className="flex items-center justify-between px-6 py-4 lg:px-12">
        
        {/* Logo */}
        <Link to="/home" className="flex items-center">
          <img src={Logo} alt="Logo" className="h-9 w-auto" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-10">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-semibold transition duration-300 ${
                  isActive
                    ? 'text-indigo-600'
                    : 'text-gray-700 hover:text-indigo-600'
                }`}
              >
                {item.name}
              </Link>
            )
          })}

          <button
            onClick={toLogout}
            className="ml-6 bg-black text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-indigo-600 transition duration-300"
          >
            Logout
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden">
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="p-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
          >
            <Bars3Icon className="h-7 w-7" />
          </button>
        </div>
      </nav>

      {/* Mobile Slide Drawer */}
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="relative z-50 lg:hidden"
      >
        {/* Overlay */}
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />

        {/* Sliding Panel */}
        <div className="fixed inset-y-0 right-0 flex max-w-full">
          <DialogPanel
            className="w-80 bg-white shadow-2xl px-6 py-6 transform transition-transform duration-300 ease-in-out"
          >
            {/* Header */}
            <div className="flex items-center justify-between">
              <img src={Logo} alt="Logo" className="h-8 w-auto" />
              <button
                onClick={() => setMobileMenuOpen(false)}
                className="p-2 rounded-md hover:bg-gray-100 transition"
              >
                <XMarkIcon className="h-6 w-6 text-gray-700" />
              </button>
            </div>

            {/* Navigation Links */}
            <div className="mt-10 flex flex-col gap-6">
              {navigation.map((item) => {
                const isActive = location.pathname === item.href
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`text-base font-semibold transition ${
                      isActive
                        ? 'text-indigo-600'
                        : 'text-gray-800 hover:text-indigo-600'
                    }`}
                  >
                    {item.name}
                  </Link>
                )
              })}

              {/* Divider */}
              <div className="border-t pt-6">
                <button
                  onClick={toLogout}
                  className="w-full bg-black text-white py-3 rounded-lg font-semibold hover:bg-indigo-600 transition"
                >
                  Logout
                </button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </header>
  )
}
